import { combineReducers } from 'redux';
import alert from './alert';
import auth from './auth';
import event from './event';
import profile from './profile';
import post from './post';
import article from './article';

export default combineReducers({
  alert,
  auth,
  event,
  profile,
  post,
  article
});
